import Button from 'common/Button';
import ButtonLarge from 'common/ButtonLarge';
import FormTextInput from 'common/FormTextInput';
import Heading from 'common/Heading';
import HeadingLarge from 'common/HeadingLarge';
import routes from 'config/routes';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { DOC_URLS, openPdfInNewTab } from 'utils/openPdfInNewTab';

import { useState } from 'react';

import InfoPopup from './InfoPopup';

const Div = styled.div`
    display: flex;
    flex-direction: column;

    .paragraph {
        color: ${(props) => props.theme.tertiaryFontColor};
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 20px;
    }

    .heading {
        color: ${(props) => props.theme.tertiaryFontColor};
        font-family: Poppins;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 30px 0 15px;
    }

    .agreements-section {
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    }

    .agreement-link {
        color: var(--highlight-accent-primary, #ff5f39);
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 10px;
        flex: 0 0 calc(35% - 20px);
        display: block;
        text-decoration: none !important; 
        
        &:hover {
            cursor: pointer;
            text-decoration: underline;
        }
    }



    .accept-section {
        margin-top: 40px;
        padding-top: 10px;
    }

    .accept-declaration {
        color: ${(props) => props.theme.tertiaryFontColor};
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 10px;
    }

    .accept-explanation {
        color: ${(props) => props.theme.tertiaryFontColor};
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 1.5;
        margin-bottom: 25px;
    }

    .accept-button {
        background-color: #ff5f39;
        color: white;
        font-family: Poppins;
        font-size: 16px;
        font-weight: 500;
        border: none;
        border-radius: 30px;
        padding: 12px 30px;
        cursor: pointer;
        transition: background-color 0.2s;
        
        &:hover {
            background-color: #e54e2a;
        }
    }

   .divider-after-accept {
        border-top: 1px solid #c4c4c4;
        margin-bottom: 20px;
    }

`;

const TermsAndConditions = () => {
    const navigate = useNavigate();

    const [conditions, setConditions] = useState({
        condition1: false,
        condition2: false,
        condition3: false,
        condition4: false,
        condition5: false,
    });

    //For now verification email is not sent to user
    // const [openPopup, setOpenPopup] = useState(false);

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setConditions((prevState) => ({
            ...prevState,
            [name]: checked,
        }));
    };
    const handleAccept = () => {
        //setOpenPopup(false);
        // navigate(routes.start);
        navigate(routes.panel.business);
    };
    return (
        <Div>
            <HeadingLarge>Read & Accept</HeadingLarge>
            <Heading>Terms and Conditions</Heading>
            <div className="paragraph mt-4">
            Please read these Terms of Service (“Terms”) carefully as they contain important information about your legal rights, remedies and obligations. By accessing or using the Be Seen Platform, you agree to comply with and be bound by these Terms.
            </div>

            <div className="paragraph">
            These Terms constitute a legally binding agreement ("Agreement") between you and Be Seen (as defined below) governing your access to and use of the Be Seen website, including any subdomains thereof, and any other websites through which Be Seen makes its services available (collectively, "Site"), our mobile, tablet and other smart device applications, and application program interfaces (collectively, "Application") and all associated services (collectively, "Be Seen Services"). The Site, Application and Be Seen Services together are hereinafter collectively referred to as the “Be Seen Platform”. 
            </div>

            <div className="heading">Practice & Provider Agreements:</div>
            <div className="divider-after-accept" />

            <div className="paragraph">
                As a practice or provider using the Be Seen Platform, you are required to review and accept the following
                agreements:
            </div>

            <div className="agreements-section">
                <span
                    className="agreement-link"
                    onClick={() => openPdfInNewTab(DOC_URLS.practiceProviderAgreementDoc)}
                >
                    Practice & Provider Agreement
                </span>
                
                <span
                    className="agreement-link"
                    onClick={() => openPdfInNewTab(DOC_URLS.providerPricingTermsScheduleDoc)}
                >
                    Provider Pricing & Payment Term Schedule
                </span>
                
                <span
                    className="agreement-link"
                    onClick={() => openPdfInNewTab(DOC_URLS.termsAndConditionDoc)}
                >
                    Terms & Conditions
                </span>
                
                <span
                    className="agreement-link"
                    onClick={() => openPdfInNewTab(DOC_URLS.privacyPolicyDoc)}
                >
                    Privacy Policy
                </span>
            </div>

            <div className="accept-section">
            <div className="accept-declaration">By clicking "I Accept", I hereby:</div>
            <div className="divider-after-accept" />

            
            <div className="accept-explanation">
                This Agreement takes effect when you click the “I Accept” button below. By clicking on the “I Accept” button below, you (1) acknowledge that you have read and understood this Agreement, (2) represent and warrant that you have the right, power, and authority to enter into this Agreement and, if entering into this Agreement for an organization, that you have the legal authority to bind that organization, and (3) accept this Agreement
                and agree that you are legally bound by its terms. If you do not agree to the terms of this Agreement, you should exit the account creation and not select the “I Accept” button.
            </div>

            <button className="accept-button" onClick={handleAccept}>
                I Accept
            </button>
            </div>

            {/* <InfoPopup open={openPopup} onClose={handleAccept} /> */}
        </Div>
    );
};
export default TermsAndConditions;
